// Entry point for the build script in your package.json
import { Application } from '@hotwired/stimulus'
const application = Application.start()
import '@hotwired/turbo-rails'

// in the setup as of 2025-07-27 esbuild had issues with copying and fingerprinting images
// workaround was to auto-generate a js import list during the build process
// this list imports the images and uses them to protect from tree-shaking
import './_node_generated_images_import_list'

// Load legacy globals like bootstrap-validator via require() or dynamic import()
import $ from 'jquery'
window.$ = window.jQuery = $
console.log('✅ jQuery is ready')
import('bootstrap-validator').then(() => {
    console.log('✅ bootstrap-validator loaded')
})
// These work without relying on jQuery
import('@popperjs/core')
import('bootstrap')
import('moment')
import('moment-timezone/builds/moment-timezone-with-data')

import './stylesheets/application.scss'

// This imports all Stimulus controllers using the generated index.js
import './controllers'

console.log('✅ running application.js')

//!-- Vendors
import './vendor/form_submission'
// import vanilla-nested for nested forms
//import 'vanilla-nested'
// copied from gems/social-share-button-1.2.4/app/assets/javascripts into javascript/vendor
import './vendor/social-share-button.coffee'

//!-- Template Functions
import './blogzine'
